/** The capability names this interface asks about, written down once.
 *
 * THESE ARE NOT AUTHORIZATION. The server decides what an administrator may do
 * and refuses on its own authority; every one of these is used to draw a screen
 * — to leave a section out of the sidebar, to disable a button that would only
 * produce a 403. Hiding a control is a courtesy, not a control.
 *
 * THE ROLE MATRIX IS DELIBERATELY NOT HERE. The browser is never told which
 * roles an administrator holds and has no table mapping roles to capabilities:
 * a second copy of that matrix would drift from the real one in
 * `backend/app/services/authz.py`, and the drift would be invisible until
 * somebody was shown a button they cannot use — or, worse, hidden one they can.
 * The session answers with capabilities, and this file only names them.
 */
export const CAP = {
  productsRead: "products.read",
  productsWrite: "products.write",
  productsMedia: "products.media",
  productsPublish: "products.publish",
  ordersRead: "orders.read",
  ordersTransition: "orders.transition",
  inventoryRead: "inventory.read",
  inventoryAdjust: "inventory.adjust",
  bulkRead: "bulk.read",
  bulkCommit: "bulk.commit",
  dashboardRead: "dashboard.read",
  usersRead: "users.read",
  usersManage: "users.manage",
} as const;

export type Capability = (typeof CAP)[keyof typeof CAP];
